/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegressionSignal } from './RegressionSignal';
import {
    RegressionSignalFromJSON,
    RegressionSignalFromJSONTyped,
    RegressionSignalToJSON,
    RegressionSignalToJSONTyped,
} from './RegressionSignal';

/**
 * 
 * @export
 * @interface DimensionRegression
 */
export interface DimensionRegression {
    /**
     * 
     * @type {string}
     * @memberof DimensionRegression
     */
    dimensionId?: string;
    /**
     * 
     * @type {number}
     * @memberof DimensionRegression
     */
    currentScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionRegression
     */
    previousScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionRegression
     */
    scoreDelta?: number;
    /**
     * 
     * @type {string}
     * @memberof DimensionRegression
     */
    severity?: string;
    /**
     * 
     * @type {Array<RegressionSignal>}
     * @memberof DimensionRegression
     */
    signals?: Array<RegressionSignal>;
}

/**
 * Check if a given object implements the DimensionRegression interface.
 */
export function instanceOfDimensionRegression(value: object): value is DimensionRegression {
    return true;
}

export function DimensionRegressionFromJSON(json: any): DimensionRegression {
    return DimensionRegressionFromJSONTyped(json, false);
}

export function DimensionRegressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DimensionRegression {
    if (json == null) {
        return json;
    }
    return {
        
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'currentScore': json['currentScore'] == null ? undefined : json['currentScore'],
        'previousScore': json['previousScore'] == null ? undefined : json['previousScore'],
        'scoreDelta': json['scoreDelta'] == null ? undefined : json['scoreDelta'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'signals': json['signals'] == null ? undefined : ((json['signals'] as Array<any>).map(RegressionSignalFromJSON)),
    };
}

export function DimensionRegressionToJSON(json: any): DimensionRegression {
    return DimensionRegressionToJSONTyped(json, false);
}

export function DimensionRegressionToJSONTyped(value?: DimensionRegression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimensionId': value['dimensionId'],
        'currentScore': value['currentScore'],
        'previousScore': value['previousScore'],
        'scoreDelta': value['scoreDelta'],
        'severity': value['severity'],
        'signals': value['signals'] == null ? undefined : ((value['signals'] as Array<any>).map(RegressionSignalToJSON)),
    };
}

